export enum LeaveStatus {
  ALL = "All",
  PENDING = "Pending",
  APPROVED = "Approved",
  REJECTED = "Rejected",
}

export enum LeaveType {
  ALL = "All",
  ANNUAL = "Annual",
  CASUAL = "Casual",
  MEDICAL = "Medical",
  UNPAID = "Unpaid",
}

export const LEAVE_STATUS_OPTIONS = [
  { value: LeaveStatus.ALL, label: "All Statuses" },
  { value: LeaveStatus.PENDING, label: "Pending" },
  { value: LeaveStatus.APPROVED, label: "Approved" },
  { value: LeaveStatus.REJECTED, label: "Rejected" },
];

export const LEAVE_TYPE_OPTIONS = [
  { value: LeaveType.ALL, label: "All Types" },
  { value: LeaveType.ANNUAL, label: "Annual" },
  { value: LeaveType.CASUAL, label: "Casual" },
  { value: LeaveType.MEDICAL, label: "Medical / Sick" },
  { value: LeaveType.UNPAID, label: "Unpaid / No-Pay" },
];

export const LEAVE_TYPE_FORM_OPTIONS = [
  { value: LeaveType.ANNUAL, label: "Annual Leave" },
  { value: LeaveType.CASUAL, label: "Casual Leave" },
  { value: LeaveType.MEDICAL, label: "Medical / Sick Leave" },
  { value: LeaveType.UNPAID, label: "Unpaid / No-Pay Leave" },
];

export interface EmployeeLeave {
  id: string;
  employee_id: string;
  leave_date: string;
  leave_type: LeaveType | string;
  status: LeaveStatus | string;
  is_nopay: number;
  approved_by?: string;
  notes?: string;
  first_name?: string;
  last_name?: string;
  nic?: string;
  designation?: string;
}
